/* @flow */

export type FetchAction = {type: "FETCH_EVENT", data: Object};
export type SetPriceLevelsAction = {type: "SET_PRICE_LEVELS", data: Object};
export type SetProductsAction = {type: "SET_PRODUCTS", data: Object};
export type UpdatePriceLevelsAction = {type: "UPDATE_PRICE_LEVELS", data: Object};
export type SetBundlesAction = {type: "SET_BUNDLES", data: Object};
export type SetChildEventAction = {type: "SET_CHILD_EVENT", data: Object};

export type Action = FetchAction | SetPriceLevelsAction| SetProductsAction | SetBundlesAction | SetChildEventAction | UpdatePriceLevelsAction;

type State = {+loading: boolean};

let initialState = { loading: true , refreshLoading: false};

export function event(state: State = initialState, action:Action): State {
    if(action.type === "FETCH_EVENT" || action.type === "REFRESH_EVENT") {
        let seller_id = Object.values(action.data.attributes.events)[0].seller_id;
        let newState = {...state, loading: false, events: {...action.data.attributes.events}, seller_id, listing: action.data.listing};
        return newState;
    } else if(action.type === "SET_PRICE_LEVELS") {
        let newState = {...state};
        newState.price_levels = action.data;
        return newState;
    } else if(action.type === "SET_PRODUCTS") {
        let newState = {...state};
        newState.products = action.data;
        return newState;
    } else if(action.type === "UPDATE_PRICE_LEVELS") {
        let newState = {...state};
        newState.price_levels = action.data;
        return newState;
    } else if(action.type === "SET_BUNDLES") {
        let newState = {...state};
        newState.bundles = action.data;
        return newState;
    } else if(action.type === "SET_CHILD_EVENT") {
        let newState = {...state};
        newState.childEvent = action.data;
        return newState;
    } else if(action.type === "SET_EVENT_REFRESH_LOADING") {
        let newState = {...state};
        newState.refreshLoading = action.value ? true : false;
        return newState;
    } else if(action.type === "SET_SERIES_EVENT_DATES") {
        if (typeof state.events === 'object' && Object.values(state.events).length) {
            let event = Object.values(state.events)[0];
            if (event.event && event.event.series) {
                return {
                    ...state,
                    events: {
                        ...state.events,
                        [event.event_id]: {
                            ...state.events[event.event_id],
                            event: {
                                ...state.events[event.event_id].event,
                                series: {
                                    ...state.events[event.event_id].event.series,
                                    eventDates: action.dates,
                                },
                            },
                        },
                    },
                };
            }
        }
        return state;
    } else if(action.type === "SET_SERIES_SOLD_OUT_DATES") {
        if (typeof state.events === 'object' && Object.values(state.events).length) {
            let event = Object.values(state.events)[0];
            if (event.event && event.event.series) {
                return {
                    ...state,
                    events: {
                        ...state.events,
                        [event.event_id]: {
                            ...state.events[event.event_id],
                            event: {
                                ...state.events[event.event_id].event,
                                series: {
                                    ...state.events[event.event_id].event.series,
                                    soldOutDates: action.dates,
                                },
                            },
                        },
                    },
                };
            }
        }
        return state;
    } else {
        return state;
    }
}
